export const formatAudioFile = (audioPath: string): string => {
  const splitPath = audioPath.split('/');
  // Get end of split path, will be name of audio file
  let audioFileDisplay = splitPath[splitPath.length - 1];
  if (audioPath.includes('voice_actor_audio')) {
    audioFileDisplay += ' (Voice actor audio)';
  }
  return audioFileDisplay;
}
